import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return <div className="footer">{/* Footer content */}</div>;
};

export default Footer;
